module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chap",
    attrs: {
      "epub:type": "chapter",
      "id": "chap-001",
      "role": "doc-chapter"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "role": "doc-pagebreak",
      "title": "9"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _vm._v(" "), _c('h1', {
    staticClass: "chap_n",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("1")])]), _vm._v(" "), _c('h1', {
    staticClass: "chap_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("His Name Is Wonderful")])]), _vm._v(" "), _c('h1', {
    staticClass: "chap_stit",
    attrs: {
      "epub:type": "subtitle",
      "role": "doc-subtitle"
    }
  }, [_c('span', [_vm._v("Messiah’s Character")])]), _vm._v(" "), _c('h1', {
    staticClass: "chap_sstit",
    attrs: {
      "epub:type": "subtitle",
      "role": "doc-subtitle"
    }
  }, [_c('span', [_vm._v("Isaiah 9:6-7")])]), _c('p', {
    staticClass: "sep_autre"
  }), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("We are all interested in names. Not long ago the world waited in anticipation to hear a royal baby’s official name. We don’t number our children; we name them. Names demonstrate our uniqueness and our personhood. One of the greatest compliments we can give another person is to call them by name.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Our names may link us to a grandparent or may be a favorite name chosen by our parents, but they don’t have much significance beyond identifying us. That is not true with most biblical names—and especially with the names God gives to himself. God’s names and titles reflect his character; they reveal what God is like.")]), _vm._v(" "), _c('p', {
    staticClass: "bl_demiligne"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROUP")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISCUSSION")]), _vm._v(". Tell the group something about your name (or a nickname) and why you like or dislike your name.")]), _vm._v(" "), _c('p', {
    staticClass: "bl_demiligne"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERSONAL")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFLECTION")]), _vm._v(". What name would God give you if he were to describe your character? What name would you give "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "role": "doc-pagebreak",
      "title": "10"
    }
  }, [_vm._v("God to describe your relationship or experience with him?")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Seven hundred years before Jesus was born, the prophet Isaiah caught a glimpse of his amazing character. God’s promised Messiah would be wonderful in every way!"), _c('i', [_vm._v(" Read Isaiah 9:6-7.")])]), _vm._v(" "), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("1. ")]), _vm._v("What words and phrases in these verses point to this promised One as a human being?")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _c('div', {
    staticClass: "lettre1"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("What evidence do you find here that he is more than a human being?")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("2. ")]), _vm._v("When you need direction or counsel, who is the first person you turn to and why do you go to that person?")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("3. ")]), _vm._v("When and how do you turn to Jesus for direction and counsel—and how does he give that counsel to you?")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("4. ")]), _vm._v("What does it mean to you today that the “Mighty God” carries sovereign authority for our world on his shoulders?")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "role": "doc-pagebreak",
      "title": "11"
    }
  }, [_c('b', [_vm._v("5. ")]), _vm._v("Isaiah’s title “Everlasting Father” can be translated “father of eternity” or “source of eternal things.” In Jesus the eternal God was joined to human time and space. In what ways do those who follow Jesus find themselves linked to eternal blessings?")])])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("6. ")]), _vm._v("The Messiah would also bring"), _c('i', [_vm._v(" shalom")]), _vm._v("—not just the absence of conflict, but well-being or true peace in every area of life. Where in your life do you need to claim Jesus’ offer of peace?")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("7. ")]), _vm._v("Which one of the four titles given to the Messiah in verse 6 fits Jesus best as you know him today?")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _c('div', {
    staticClass: "lettre1"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Which title seems most distant from your experience and why?")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("8. ")]), _vm._v("How would you describe the scope and permanence of the Messiah’s reign from these two verses?")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "lettre"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("9. ")]), _vm._v("In what ways does Jesus reign over your life, and how can you submit more fully to his lordship?")])]), _vm._v(" "), _c('form', {
    attrs: {
      "action": "traitement.php",
      "method": "post",
      "name": "response"
    }
  }, [_c('p', [_c('label'), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    attrs: {
      "aria-label": "p1",
      "name": "response"
    }
  })])]), _c('p', {
    staticClass: "bl"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("As you pray, submit yourself or some area of your life completely to Jesus. Let his peace enfold you.")])]), _vm._v(" "), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-001"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "role": "doc-pagebreak",
      "title": "12"
    }
  }, [_c('h2', {
    staticClass: "int_niv2",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("Now or Later")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("George Frideric Handel’s"), _c('i', [_vm._v(" Messiah")]), _vm._v(" is a musical phenomenon. Every year this masterful piece is performed hundreds of times by everyone from well-rehearsed choirs with scores of voices to “join in where you can” community sing-alongs.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Handel’s work belongs to the musical genre of oratorio. Like operas, oratorios are dramatic stories set entirely to music for soloists, choir or chorus, and orchestra. Unlike opera, oratorios do not include acting, costumes or stage scenery. Oratorios usually tell sacred stories drawn from the Bible or the lives of Christian saints.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('i', [_vm._v("Messiah")]), _vm._v(" is a combination of the music of Handel and the text compiled by Charles Jennings. Jennings drew every word from the Bible (sometimes the King James Version and sometimes from the translation used in the Book of Common Prayer).")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The Old Testament writers promised that the coming of the Messiah would bring light into the darkness of a world shrouded in sin and death. In part 1, scene 3, section 2 of"), _c('i', [_vm._v(" Messiah")]), _vm._v(", darkness gives way to glorious light. The bass soloist sings a wandering melody, depicting our aimless journey in spiritual darkness. But then light begins to pierce the darkness.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The light is the virgin’s child, Emmanuel. The scene reaches its climax in the coming of a Redeemer who will scatter the darkness with his presence and power—“for unto us a child is born.”")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Listen to both the aria (“The people that walked in darkness”) and the chorus (“For unto us a child is born”). If you have access to the musical score, sing along with the soloist and the chorus. This is every Christian’s story! We have seen the light in the face of Jesus.")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d79414a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap1.vue
// module id = 66
// module chunks = 0